import { useEffect, useRef } from 'react';
import { getIn, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { slugify } from '@/utils/helpers';
import FormikInput from './FormikInput';

// Autofills slug when the user edits a source field, while slug is empty or still auto-generated
const FormikSlugInput = ({ name = 'slug', sourceNames = [], ...props }) => {
  const { t } = useTranslation();
  const { values, initialValues, setFieldValue } = useFormikContext();
  const autoSlug = useRef('');
  const getSource = (data) => sourceNames.map((sourceName) => getIn(data, sourceName)).find(Boolean) || '';
  const source = getSource(values);
  const initialSource = getSource(initialValues);

  useEffect(() => {
    const current = getIn(values, name) || '';
    if (!source || source === initialSource || (current && current !== autoSlug.current)) return;
    const nextSlug = slugify(source);
    autoSlug.current = nextSlug;
    if (nextSlug !== current) setFieldValue(name, nextSlug);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source]);

  return <FormikInput name={name} label={t('slug')} placeholder={t('slug_hint')} {...props} />;
};

export default FormikSlugInput;
